/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import Layout from '@shared/components/layout'
import queryGraphql from '@shared/components/queryGraphql'
import { pageLoading } from '@shared/libs/allLoader'
import {
  LIST_CATEGORY_WISE_VIDEO,
  GET_TRENDING_VIDEO,
  GET_SHORTS
} from '@graphql/videos/videos.query'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import { GET_SEARCH_VIDEO } from '@graphql/search/search.query'
import { handleApiError } from '@shared-submodule/utils'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

// const GoogleAds = dynamic(() => import('@shared-submodule/sm-components/googleAds'), { ssr: false })
const Shorts = dynamic(() => import('@shared/components/video/shorts'), { loading: () => pageLoading() })
const CategoryVideos = dynamic(() => import('@shared/components/video/categoryVideos'), { loading: () => pageLoading() })
const BrandAmbassador = dynamic(() => import('@shared/components/brandAmbassador'), { loading: () => pageLoading() })
const PopularVideos = dynamic(() => import('@shared/components/popularVideos'), { loading: () => pageLoading() })
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })
const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

const Videos = ({
  trendingVideos,
  videos,
  playlist,
  seoData,
  brandVideo,
  shorts
}) => {
  const categoryVideos = videos?.aResults
  const totalCategory = videos?.nTotal
  const brandAmbassadorVideo = brandVideo?.aResults.filter((video) => {
    return video.sTitle.includes('Brand Ambassador')
  })
  const shortVideos = shorts?.aResults

  // console.log({
  //   trendingVideos: trendingVideos,
  //   videos: videos,
  //   playlist: playlist,
  //   seoData: seoData,
  //   brandVideo: brandVideo,
  //   shorts: shorts
  // })

  const { addRight } = reviveAdData
  return (
    <Layout data={{ oSeo: seoData }}>
      {
        shortVideos?.length > 0 && <Shorts video={shortVideos} />
      }
      <main className='common-section pt-0 pb-0 mb-4'>
        <ATSAds />
        <Container>
          <Row>
            <Col lg={9} className='left-content'>
              <CategoryVideos data={categoryVideos} nTotal={totalCategory} />
            </Col>
            <Col lg={3} className='common-sidebar'>
              {/* {
                brandAmbassadorVideo && (
                  <BrandAmbassador data={brandAmbassadorVideo[0]} />
                )
              } */}
              <PopularVideos />
              {/* <GoogleAds
                addId={googleAddData?.addRight?.addId}
                divId={googleAddData?.addRight?.divId}
                dimension={googleAddData?.addRight?.dimension}
                slotId={googleAddData?.addRight?.slotId}
                className={'sticky_ads'}
              /> */}
              <ReviveAds {...addRight} className={'d-flex justify-content-center sticky_ads'}/>
            </Col>
          </Row>
        </Container>
      </main>
    </Layout>
  )
}

Videos.propTypes = {
  videos: PropTypes.object,
  playlist: PropTypes.object,
  seoData: PropTypes.object,
  trendingVideos: PropTypes.object,
  brandVideo: PropTypes.object,
  shorts: PropTypes.array
}

export default Videos

export const getSearchPayload = () => {
  return {
    nLimit: 7,
    nSkip: 1,
    sSearch: 'virat kohli'
  }
}

export async function getServerSideProps({ res, resolvedUrl }) {
  // return { notFound: true }
  try {
    const { allRoutes } = (await import('@shared-submodule/sm-constants/allRoutes'))
    const { checkRedirectionStatus } = (await import('@shared-submodule/utils'))
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: allRoutes.cricketVideosNew } })
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj

    const { data: videos } = await queryGraphql(LIST_CATEGORY_WISE_VIDEO, { input: { nLimit: 3, nSkip: 1 } })

    const { data: trendingVideos } = await queryGraphql(GET_TRENDING_VIDEO, { input: { nLimit: 5, nSkip: 1 } })

    const { data: brandVideo } = await queryGraphql(GET_SEARCH_VIDEO, { input: getSearchPayload() })

    const { data: shorts } = await queryGraphql(GET_SHORTS, {
      input: {
        nSkip: 1,
        nLimit: 7,
        bShorts: true
      }
    })
    return {
      props: {
        seoData: seoData?.getSeoData,
        videos: videos?.listCategoryWiseVideo,
        trendingVideos,
        brandVideo: brandVideo?.getVideoSearch,
        shorts: shorts?.listVideosFront
      }
    }
  } catch (e) {
    console.log(e)
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
